export class FilterModelFetchSizeModel {
  static ALL = -1;
  static TOP_10 = 10;
  static TOP_20 = 20;
  static TOP_50 = 50;

  label: string;
  size: number;

  constructor(label: string, size: number) {
    this.label = label;
    this.size = size;
  }
}
